<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <div class="row mb-3 pt-3">
    <div class="col-md-6">
      <h5><a [routerLink]="['../']"> Conferences</a> > Expense Management</h5>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-md-8">
      <h4 class="h3 font-weight-medium mb-1">{{ speaker.conferenceName }}</h4>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-sm btn-admin-primary" type="button" (click)="addEditExpense(null)">Add Expense</button>
    </div>
  </div>
  <div *ngIf="!auth.user.stripeLinked" class="row p-3">
    <div class="col-md-12 alert alert-danger">
      <div class="row">
        <div class="col-md-10">
          <span class="font-size-2 mr-2"><i class="fas fa-exclamation-triangle"></i></span>You have not linked your banking information yet. In order for this conference to pay you electronically, please link your banking and tax information.
        </div>
        <div class="col-md-2 text-right">
          <a class="btn btn-sm btn-admin-primary" href="{{ stripeUrl }}">Link </a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="auth.user.stripeLinked" class="row p-3">
    <div class="col-md-12 alert alert-success">Your banking & tax information is linked and you are ready to get paid!</div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div *ngIf="!speaker.expenses || speaker.expenses.length == 0" class="row no-gutters no-candidates" style="min-height: 200px">
        <div class="col-sm-12 my-auto">
          <h1><i class="fas fa-empty-set"></i></h1>
          <h4>No Expenses</h4>
          <p>There have been no expenses added yet for this speaker.</p>
          <button class="btn btn-sm btn-admin-primary" type="button" (click)="addEditExpense(null)">Add Expense</button>
        </div>
      </div>
      <table *ngIf="speaker.expenses && speaker.expenses.length > 0" class="table table-bordered-outside table-hover bg-white">
        <thead class="bg-light">
          <tr>
            <th>Date</th>
            <th>Description</th>
            <th>Amount</th>
            <th>Amount Approved</th>
            <th class="text-center">Paid</th>
            <th>Receipt</th>
            <th class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let expense of speaker.expenses">
            <td>{{ expense.date | date }}</td>
            <td>{{ expense.description }}</td>
            <td>{{ expense.amount | currency }}</td>
            <td>{{ expense.approvedAmount | currency }}</td>
            <td class="text-center"><i *ngIf="expense.paid" class="fas fa-check-circle text-success"></i> <i *ngIf="!expense.paid" class="fas fa-times-circle text-danger"></i></td>
            <td>
              <a *ngIf="expense.receiptImage" href="javascript:void(0)" (click)="downloadReceipt(expense)">Download</a>
              <span *ngIf="!expense.receiptImage">No Receipt</span>
            </td>
            <td>
              <div class="dropdown text-right">
                <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" href="javascript:void(0)" (click)="addEditExpense(expense)">Edit Expense</a>
                  <a *ngIf="!expense.paid" class="dropdown-item" href="javascript:void(0)" (click)="deleteExpense(expense)">Delete Expense</a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
